import React from 'react';

export const PodiumPickerIcon = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="pp-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#667eea"/>
        <stop offset="100%" stopColor="#764ba2"/>
      </linearGradient>
    </defs>
    {/* Background rounded square */}
    <rect width="64" height="64" rx="14" fill="url(#pp-bg)"/>
    {/* Car body */}
    <ellipse cx="32" cy="37" rx="22" ry="6" fill="white" fillOpacity="0.9"/>
    {/* Cockpit */}
    <ellipse cx="30" cy="31" rx="9" ry="5" fill="white"/>
    {/* Front wing */}
    <rect x="48" y="38" width="10" height="3" rx="1" fill="#FFD700"/>
    {/* Rear wing */}
    <rect x="6" y="33" width="10" height="3" rx="1" fill="#FFD700"/>
    {/* Front tyre */}
    <circle cx="48" cy="43" r="5" fill="#15151e"/>
    {/* Rear tyre */}
    <circle cx="18" cy="43" r="6" fill="#15151e"/>
    {/* Halo arc */}
    <path d="M23 30 Q31 23 39 30" stroke="#FFD700" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
  </svg>
);

export default PodiumPickerIcon;
